<template>
<div>
  <div class="bk-blue secret-blue ">
    <div class="container">
    <h2><span>Secretul 3<br></span>Oligozaharidele din laptele matern <br> și beneficiile lor pentru
        imunitate</h2>
    <p>Primii ani de viață sunt cei mai importanți pentru dezvoltarea sistemului imunitar, <br> dar cum contribuie oligozaharidele din lapte matern la acest proces?
    </p>
    </div>
  </div>
</div>
</template>

<script>
export default {
    components: {},
    data() {
        return {}
    },
}
</script>
<style scoped lang="scss">

</style>
